import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'
import { getFormattedDateTimeString } from 'Global/Helpers/timeHelpers'

import CardProperty from 'Components/CardProperty'

const FAPictureCardInformation = ({ picture }) => {
  return (
    <Card.Content extra>
      <List>
        <CardProperty icon="hashtag" popUpContent="Event">
          {picture.eventName}
        </CardProperty>

        <CardProperty icon="calendar" popUpContent="Shoot Date">
          {getFormattedDateTimeString(picture.createdAt)}
        </CardProperty>
      </List>
    </Card.Content>
  )
}

FAPictureCardInformation.propTypes = {
  picture: PropTypes.object.isRequired,
}

export default FAPictureCardInformation
